import { Component } from '@angular/core';
import { EmptyStateComponent } from '@ra-web-tech-ui-toolkit/components';
import { INoRowsOverlayAngularComp } from 'ag-grid-angular';
import { INoRowsOverlayParams } from 'ag-grid-community';

type NoRowsOverlayParams = INoRowsOverlayParams & {
  title?: string;
  content?: string;
};

@Component({
  selector: 'app-no-rows-overlay',
  templateUrl: './ag-custom-no-rows-overlay.component.html',
  styleUrl: './ag-custom-no-rows-overlay.component.scss',
  imports: [EmptyStateComponent],
})
export class AgCustomNoRowsOverlayComponent implements INoRowsOverlayAngularComp {
  params: Partial<NoRowsOverlayParams> = {};

  agInit(params: INoRowsOverlayParams): void {
    this.params = params as NoRowsOverlayParams;
  }
}
